import { render, staticRenderFns } from "./DisplayField.vue?vue&type=template&id=db1b7cfe&"
import script from "./DisplayField.vue?vue&type=script&lang=js&"
export * from "./DisplayField.vue?vue&type=script&lang=js&"
import style0 from "./DisplayField.vue?vue&type=style&index=0&lang=sass&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports